import { forwardRef } from 'react';

import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { FormFieldContainer } from '@bambi/component-library/src/components/forms/layout/FormFieldContainer';
import { SupportedGridSizes } from '@bambi/component-library/src/components/forms/layout/FormFieldSet';

import Switch from 'src/common/primitives/Switch';

import type { HelperText } from '@bambi/component-library/src/components/forms/FormFieldHelperText/FormFieldHelperText';

export type CoreFormFieldSwitchProps = {
  label: React.ReactNode;
  error?: string;
  helperText?: HelperText;
  colSpan?: SupportedGridSizes;
  inline?: boolean;
  inputProps: {
    id?: string;
    disabled?: boolean;
    value?: boolean;
    onChange?: (val: boolean) => void;
  };
  /**
   * This is a temporary prop that when true will also pass the value into
   * `checked`. This value is necessary to ensure the switch is rendered its
   * initial state correctly. Will remove once all of the forms that use this
   * have been updated.
   */
  passChecked?: boolean;
};

export const CoreFormFieldSwitch = forwardRef(function _CoreFormFieldSwitch(
  {
    inputProps,
    label,
    error,
    helperText,
    colSpan,
    inline,
    passChecked,
  }: CoreFormFieldSwitchProps,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <FormFieldContainer colSpan={colSpan}>
      <DefaultFormFieldLayout
        label={label}
        inputId={inputProps.id}
        helperText={helperText}
        error={error}
        inline={inline}
      >
        <Switch
          data-testid={inputProps.id}
          label={label}
          inputProps={{
            ...inputProps,
            ...(passChecked
              ? {
                  checked: inputProps.value,
                }
              : {}),
          }}
          ref={ref}
        />
      </DefaultFormFieldLayout>
    </FormFieldContainer>
  );
});
